import { api_url } from "../../../utils";

const Distritos = {
    enable: true,
    checked: false,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=distritos&schema_city=",
    zindex: 1,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    distrito: "Nombre del distrito: ",
                },
            },
            separators: {
                decimal: [],
                thousand: [],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Distritos",
    style: {
        regular: false,
        fillColor: "rgba(255, 255, 255, 0)",
        strokeColor: "rgb(0, 0, 0)",
        strokeWidth: 1.5,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Distritos.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass: "map-legend-symbol-border-1-5px-dark-0-0-0",
            class: [
                {
                    fillColor: "rgba(0, 0, 0, 0)",
                    strokeColor: "rgba(0, 0, 0, 1)",
                    strokeWidth: 3,
                    label: "Mobility Indicators Content.layersLegend.Distritos.classes.1",
                },
            ],
        },
    },
};

export default Distritos;
